import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { InternalMember } from '../../models/member/internal-member.model';
import { ExchangeApiService } from '../exchange-api.service';

@Injectable({
  providedIn: 'root',
})
export class InternalMemberRepository {

  private readonly baseUrl = 'internal_members';

  constructor(
    private exchangeApiService: ExchangeApiService,
  ) {
  }

  public get(id: string): Observable<InternalMember> {
    return this.exchangeApiService
      .getSave(`${this.baseUrl}/${id}`)
      .pipe(
        map(response => new InternalMember(response)),
      );
  }

  public getManagers(member: InternalMember): Observable<InternalMember[]> {
    return this.exchangeApiService.getSave(`${this.baseUrl}/${member.id}/managers`)
      .pipe(
        map(managers => managers.map(manager => new InternalMember(manager))),
      );
  }
}
